import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./About.css";
import TestimonialSlider from "../../Components/Testimonial";
import { Slide, Fade, Zoom, Rotate, Roll } from "react-awesome-reveal";
import about1 from './images/about1.png';
import aboutImg from '../../assets/images/about_us_img1.jpg'

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, []);

  return (


    <>

<div className="floating-icons">
        <a className="icon" href='https://www.facebook.com/login.php/' target='_blank'>
          <button

            className="sm_icon"
          >
            <img src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/em6rzkumkpu9thoz7xyi.png' alt="facebook" />
          </button>
        </a>
        <a className="icon" href='https://www.instagram.com/hamotechsd/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780083/cqpiobs4yhxfbs9eneg4.png' alt="instagram" />
          </button>
        </a>
        <a className="icon" href='https://www.linkedin.com/company/105967594/admin/page-posts/published/' target='_blank'>
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780082/btlz8e3ziogli6p2blkh.png' alt="linkedin" />
          </button>
        </a>
        <a className="icon" href="https://wa.me/+918688964015" target="_blank">
          <button className="sm_icon">
            <img
              src='https://res.cloudinary.com/dprcylred/image/upload/v1737780217/eauw0ts2blhbrycxk1mk.png' alt="whatsapp" />
          </button>
        </a>
      </div>

      
      <div className="content-wrapper js-content-wrapper overflow-hidden about_section" style={{ marginTop: "100px" }}>
        {/* <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-auto">
              <div className="breadcrumbs__content">
                <div className="breadcrumbs__item  ">
                  <Link to="/">Home</Link>
                </div>
                <div className="breadcrumbs__item  ">
                  <Link to="/">About Us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

        <section className="page-header -type-1">
          <div className="container-fluid">
            <div className="page-header__content">
              <div className="row justify-center text-center">
                <div className="col-auto">
                  <Fade direction="up" delay={200}>
                    <div>
                      <h1 className="page-header__title" style={{ color: "#e65753" }}>About Us</h1>
                    </div>
                    <div>
                      <p className="page-header__text aboutPage_content1 text-justify">
                        At <b>Hamo Tech</b>, we believe in empowering individuals
                        through education. Our mission is to provide high-quality,
                        engaging, and expertly curated courses that are accessible
                        to everyone, regardless of their background or experience
                        level.
                      </p>
                      <p className="text-justify" style={{ color: "#4d4d4d" }}>HAMO Tech is a dynamic and innovative company committed to delivering top-tier engineering and IT services to businesses worldwide. We are driven by a passion for technology and a dedication to helping organizations achieve their goals through tailored, high-quality solutions. With a customer-centric approach and a team of experienced professionals, HAMO Tech is a trusted partner for companies seeking to excel in today’s competitive landscape.</p>
                      <p className="text-justify" style={{ color: "#4d4d4d" }}>At HAMO Tech, we believe in the power of innovation to transform industries. By staying ahead of technological trends and leveraging advanced tools and methodologies, we provide solutions that are not only effective but also future-proof. Our expertise spans across engineering, IT services, and consulting, enabling us to cater to a wide range of industries and business needs.</p>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-md layout-pb-lg">
          <div className="container">
            <div className="row y-gap-50 justify-between items-center">
              <div className="col-lg-6 pr-50 sm:pr-15">
                <Zoom delay={500}>
                  <div className="composition -type-8">
                    <div className="-el-1">
                      <img
                        src={aboutImg}
                        alt="about img1"
                        className="img-fluid"
                      // style={{ transform: "rotateY(150deg)" }}
                      />
                    </div>
                    {/* <div className="-el-1">
                    <img
                      src="https://i.insider.com/664e42809fc063e829b3ddc9?width=700"
                      alt="about img2"
                      style={{ width: "200px" }}
                    />
                  </div>
                  <div className="-el-1">
                    <img
                      src={about1}
                      alt="about img3"
                      style={{ borderTopRightRadius: "100px" }}
                      className="img-fluid"
                    />
                  </div> */}
                  </div>
                </Zoom>
              </div>
              <div className="col-lg-5">
                <Fade direction="up" delay={500}>
                  <h2 className="text-30 lh-16 aboutPage_content2">
                    Welcome to<br /> <span>Hamo Tech</span> – Empowering you
                    with top-notch online courses to achieve your goals!
                  </h2>
                  <p className="text-dark-1 mt-30 aboutPage_p1">
                    Complete these popular courses in less than a day – all for
                    free! Explore the list below and start learning today.
                  </p>
                  <p className=" mt-25 aboutPage_p1">
                    We’re dedicated to fostering a learning environment that
                    combines practical knowledge, innovative tools, and
                    industry-relevant skills at a price that won’t break the bank.
                    Whether you’re a student, professional, or lifelong learner,
                    our goal is to help you unlock your potential and achieve your
                    ambitions.
                  </p>
                  <p className=" mt-25 aboutPage_p1">
                    What sets HAMO Tech apart is our unwavering commitment to quality. From the initial stages of design and development to the final delivery, we ensure that every solution meets the highest standards. Our team of skilled professionals brings years of experience and a deep understanding of the latest technologies, ensuring that our clients receive the best possible results.
                  </p>
                  <div className="d-inline-block">
                    <Link
                      to="/contact-us"
                      className="button -md -purple-1 text-white mt-30"
                    >
                      Start Learning For Free
                    </Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section className="about_new_content">
          <p>HAMO Tech takes pride in offering personalized solutions that align with the unique needs of each client. We understand that no two businesses are the same, which is why we work closely with our clients to understand their challenges and craft solutions that drive success. Our focus on building strong, lasting relationships with our clients ensures that we are not just service providers but trusted partners in their growth journey.</p>
          <p>In addition to our technical expertise, HAMO Tech is committed to sustainability and responsible business practices. We believe in creating solutions that contribute to a greener, more sustainable future. Whether it’s through eco-friendly engineering projects or energy-efficient IT systems, we strive to make a positive impact on the environment and the communities we serve.</p>
          <p>HAMO Tech is more than just a technology company. We are a team of innovators, problem-solvers, and collaborators who are passionate about helping businesses achieve their goals. Join us on a journey of innovation and excellence, and let’s create a brighter future together.</p>
        </section>

        <section className="layout-pt-lg layout-pb-lg">
          <div className="container">
            <div className="row y-gap-20 justify-center text-center">
              <div className="col-auto">
                <div className="sectionTitle ">
                  <h2 className="sectionTitle__title ">How it works?</h2>
                  <p className="sectionTitle__text ">
                    6,000+ unique online course list designs
                  </p>
                </div>
              </div>
            </div>
            <div className="row y-gap-30 justify-between pt-60 lg:pt-40">
              <div className="col-xl-2 col-lg-3 col-md-6">
                <Fade direction="up" delay={200}>
                  <div className="d-flex flex-column items-center text-center">
                    <div className="relative size-120 d-flex justify-center items-center rounded-full bg-light-4">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-3/works/1.svg"
                        alt="about-img4"
                      />
                      <div className="side-badge">
                        <div className="size-35 d-flex justify-center items-center rounded-full bg-dark-1 -dark-bg-purple-1">
                          <span className="text-14 fw-500 text-white">01</span>
                        </div>
                      </div>
                    </div>
                    <div className="text-17 fw-500 text-dark-1 mt-30">
                      Browse courses from our expert contributors.
                    </div>
                  </div>
                </Fade>
              </div>
              <div className="col-auto xl:d-none">
                <Slide>
                  <div className="pt-30">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/misc/lines/1.svg"
                      alt="about-img5"
                    />
                  </div>
                </Slide>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-6">
                <Fade direction="up" delay={400}>
                  <div className="d-flex flex-column items-center text-center">
                    <div className="relative size-120 d-flex justify-center items-center rounded-full bg-light-4">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-3/works/2.svg"
                        alt="about-img4"
                      />
                      <div className="side-badge">
                        <div className="size-35 d-flex justify-center items-center rounded-full bg-dark-1 -dark-bg-purple-1">
                          <span className="text-14 fw-500 text-white">02</span>
                        </div>
                      </div>
                    </div>
                    <div className="text-17 fw-500 text-dark-1 mt-30">
                      Purchase quickly and securely.
                    </div>
                  </div>
                </Fade>
              </div>
              <div className="col-auto xl:d-none">
                <Slide delay={300}>
                  <div className="pt-30">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/misc/lines/2.svg"
                      alt="about-img5"
                    />
                  </div>
                </Slide>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-6">
                <Fade direction="up" delay={600}>
                  <div className="d-flex flex-column items-center text-center">
                    <div className="relative size-120 d-flex justify-center items-center rounded-full bg-light-4">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-3/works/3.svg"
                        alt="about-img4"
                      />
                      <div className="side-badge">
                        <div className="size-35 d-flex justify-center items-center rounded-full bg-dark-1 -dark-bg-purple-1">
                          <span className="text-14 fw-500 text-white">03</span>
                        </div>
                      </div>
                    </div>
                    <div className="text-17 fw-500 text-dark-1 mt-30">
                      That’s it! Start learning right away.
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section className="section-bg layout-pt-lg layout-pb-md">
          <div className="section-bg__item -full -height-half bg-dark-5"></div>
          <div className="container">
            <div className="row justify-center text-center">
              <div className="col-auto">
                <Fade direction="up" delay={200}>
                  <div className="sectionTitle ">
                    <h2 className="sectionTitle__title text-white">
                      Start your Learning Journey Today!
                    </h2>
                    <p className="sectionTitle__text text-white">
                      Embark on a transformative journey with our expertly crafted
                      courses. Gain new skills, enhance your knowledge, and
                      achieve your goals—all at your own pace!
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row y-gap-30 justify-between pt-60 lg:pt-50">
              <div className="col-lg-3 col-md-6">
                <Slide direction="left" delay={300}>
                  <div className="coursesCard -type-2 text-center pt-50 pb-40 px-30 rounded-8 bg-white shadow-2 aos-init aos-animate">
                    <div className="coursesCard__image">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-5/learning/1.svg"
                        alt="about-img6"
                      />
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Master Your Skills with Industry Experts
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Gain knowledge from top professionals with real-world
                        experience.
                      </p>
                    </div>
                  </div>
                </Slide>
              </div>
              <div className="col-lg-3 col-md-6">
                <Slide direction="left" delay={500}>
                  <div className="coursesCard -type-2 text-center pt-50 pb-40 px-30 rounded-8 bg-white shadow-2 aos-init aos-animate">
                    <div className="coursesCard__image">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-5/learning/2.svg"
                        alt="about-img6"
                      />
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Master Any Skill
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Expand your knowledge and unlock new opportunities with
                        courses designed to help you.
                      </p>
                    </div>
                  </div>
                </Slide>
              </div>
              <div className="col-lg-3 col-md-6">
                <Slide direction="right" delay={300}>
                  <div className="coursesCard -type-2 text-center pt-50 pb-40 px-30 rounded-8 bg-white shadow-2 aos-init aos-animate">
                    <div className="coursesCard__image">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-5/learning/3.svg"
                        alt="about-img6"
                      />
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Learn at Your Own Pace
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        With flexible learning options, you can study whenever and
                        wherever it suits you.
                      </p>
                    </div>
                  </div>
                </Slide>
              </div>
              <div className="col-lg-3 col-md-6">
                <Slide direction="right" delay={500}>
                  <div className="coursesCard -type-2 text-center pt-50 pb-40 px-30 rounded-8 bg-white shadow-2 aos-init aos-animate">
                    <div className="coursesCard__image">
                      <img
                        src="https://educrat-react.vercel.app/assets/img/home-5/learning/4.svg"
                        alt="about-img6"
                      />
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Industry-Ready Skills
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Gain practical knowledge and hands-on experience to meet
                        the demand.
                      </p>
                    </div>
                  </div>
                </Slide>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-lg layout-pb-lg section-bg">
          <div className="section-bg__item  bg-light-6"></div>
          <div className="container">
            <div className="row y-gap-20 justify-center text-center">
              <div className="col-auto">
                <Fade direction="up" delay={200}>
                  <div className="sectionTitle">
                    <h2 className="sectionTitle__title ">Testimonials</h2>
                    <p className="sectionTitle__text ">
                      6,000+ unique online course list designs
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row justify-center pt-60">
              <div className="col-xl-6 col-lg-8 col-md-10">
                <TestimonialSlider />
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-md layout-pb-md">
          <div className="container">
            <div className="row justify-center text-center">
              <div className="col-auto">
                <Fade direction="up" delay={200}>
                  <div className="sectionTitle">
                    <h2 className="sectionTitle__title ">
                      Why Choose <span style={{ color: "#ea3437" }}>Hamo Tech</span>?
                    </h2>
                    <p className="sectionTitle__text ">
                      <b style={{ color: "#ea3437" }}>Hamo Tech</b> provides cutting-edge tech education with
                      hands-on experience to ensure students are industry-ready.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
            <div className="row y-gap-30 justify-between pt-60 lg:pt-50">
              <div className="col-lg-3 col-md-6">
                <Fade direction="up" delay={300}>
                  <div className="coursesCard -type-3 px-0 text-center">
                    <div className="coursesCard__icon bg-white shadow-2">
                      <i class="ri-user-community-line"></i>
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Master New Skills
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Learn anything at your own pace and advance your knowledge
                        in the fields of technology and innovation.
                      </p>
                    </div>
                  </div>
                </Fade>
              </div>

              <div className="col-lg-3 col-md-6">
                <Fade direction="up" delay={300}>
                  <div className="coursesCard -type-3 px-0 text-center">
                    <div className="coursesCard__icon bg-white shadow-2">
                      <i class="ri-group-2-line"></i>
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Empower Your Future
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Learn together and grow your skills with Hamo Tech
                        
                      </p>
                    </div>
                  </div>
                </Fade>
              </div>

              <div className="col-lg-3 col-md-6">
                <Fade direction="up" delay={400}>
                  <div className="coursesCard -type-3 px-0 text-center">
                    <div className="coursesCard__icon bg-white shadow-2">
                      <i class="ri-user-star-line"></i>
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Expert Learning at Hamo
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        At Hamo Tech, we provide expert guidance to help
                        you grow and excel in the tech industry.
                      </p>
                    </div>
                  </div>
                </Fade>
              </div>

              <div className="col-lg-3 col-md-6">
                <Fade direction="up" delay={500}>
                  <div className="coursesCard -type-3 px-0 text-center">
                    <div className="coursesCard__icon bg-white shadow-2">
                      <i class="ri-secure-payment-line"></i>
                    </div>
                    <div className="coursesCard__content mt-30">
                      <h5 className="coursesCard__title text-18 lh-1 fw-500">
                        Lifetime Access to All Courses
                      </h5>
                      <p className="coursesCard__text text-14 mt-10">
                        Get lifetime access to all the courses at Hamo Tech
                        . Learn at your own pace, with no
                        expiration date on your learning experience.
                      </p>
                    </div>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-lg layout-pb-md">
          <div className="container">
            <div className="row y-gap-30 items-center">
              <div className="col-xl-5 offset-xl-1 col-lg-6">
                <Roll delay={200}>
                  <img
                    src="https://media.wired.com/photos/647e7400d96882f74caa3e5c/master/pass/Don't-Want-Students-To-Rely-On-ChatGPT-Ideas-1356557660.jpg"
                    alt="about-img7"
                    className="w-1/1"
                  />
                </Roll>
              </div>
              <div className="col-xl-4 offset-xl-1 col-lg-6">
                <Fade direction="up" delay={200}>
                  <h3 className="text-24 lh-1">Join Our Team of Instructors</h3>
                  <p className="mt-20" style={{ color: "#767676" }}>
                    Share your expertise and help shape the future of technology
                    by becoming an instructor at Hamo Tech
                  </p>
                  <div className="d-inline-block mt-20">
                    <Link
                      className="button -md -outline-purple-1 text-purple-1"
                      to="/contact-us"
                    >
                      Apply Now
                    </Link>
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-lg layout-pb-md">
          <div className="container">
            <div className="row y-gap-30 items-center">
              <div className="col-xl-4 offset-xl-1 col-lg-6">
                <Fade direction="up" delay={300}>
                  <h3 className="text-24 lh-1">Become a Part of Our Community</h3>
                  <p className="mt-20" style={{ color: "#767676" }}>
                    Join thousands of learners worldwide in mastering new skills.
                    Online learning is interactive, engaging, and accessible for
                    everyone.
                  </p>
                  <div className="d-inline-block mt-20">
                    <Link
                      className="button -md -outline-purple-1 text-purple-1"
                      to="/contact-us"
                    >
                      Start Now
                    </Link>
                  </div>
                </Fade>
              </div>

              <div className="col-xl-5 offset-xl-1 col-lg-6">
                <Rotate delay={200}>
                  <img
                    src="https://s39613.pcdn.co/wp-content/uploads/2018/12/meta-teaching-181210.jpg"
                    alt="about-img7"
                    className="w-1/1"
                  />
                </Rotate>
              </div>
            </div>
          </div>
        </section>

        <section className="layout-pt-lg  layout-pb-md">
          <div className="container">
            <div className="row justify-center">
              <div className="col text-center">
                <p className="text-lg text-dark-1">
                  Relied upon by top organizations worldwide.
                </p>
              </div>
            </div>
            <div className="row y-gap-30 justify-between sm:justify-start items-center pt-60 md:pt-50">
              <Slide left cascade duration={1000}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/1.svg"
                      className="w-1/1"
                      alt="about-img1"
                    />
                  </div>
                </div>
              </Slide>
              <Slide left cascade duration={1500}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/2.svg"
                      className="w-1/1"
                      alt="about-img2"
                    />
                  </div>
                </div>
              </Slide>
              <Slide left cascade duration={2000}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/3.svg"
                      className="w-1/1"
                      alt="about-img3"
                    />
                  </div>
                </div>
              </Slide>
              <Slide left cascade duration={2500}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/4.svg"
                      className="w-1/1"
                      alt="about-img4"
                    />
                  </div>
                </div>
              </Slide>
              <Slide left cascade duration={3000}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/5.svg"
                      className="w-1/1"
                      alt="about-img5"
                    />
                  </div>
                </div>
              </Slide>
              <Slide left cascade duration={3500}>
                <div>
                  <div className="d-flex justify-center items-center px-4">
                    <img
                      src="https://educrat-react.vercel.app/assets/img/clients/6.svg"
                      className="w-1/1"
                      alt="about-img6"
                    />
                  </div>
                </div>
              </Slide>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default About;
